// extracted by css-extract-rspack-plugin
export default {"container":"Selection-module__container__uheUU","checkbox":"Selection-module__checkbox__dpjxE"};